'use strict'

const identity_ = require('lodash/identity')

const addRavenData = (Raven, extraData, key) => {
  Raven.setDataCallback((data, originalCallback = identity_) => {
    data.extra = data.extra || {}
    data.extra[key] = Object.assign({}, data.extra[key], extraData)

    return originalCallback(data)
  })
}

module.exports = addRavenData



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/raven/addRavenData.js